























import { Component, Prop, Vue } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
@Component({
  components: { MpCard }
})
export default class MpShowNumberCard extends Vue {
  @Prop()
  height!: string;

  @Prop()
  title!: string;

  @Prop()
  description!: string;

  @Prop()
  value!: number;
}
